(() => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-primary-nav]');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-media-swap]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-product-main-image]');
      const src = button.getAttribute('data-src');
      const alt = button.getAttribute('data-alt') || '';
      if (!target || !src) return;
      target.setAttribute('src', src);
      target.setAttribute('alt', alt);
    });
  });
})();
